import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import CardInstruction from '../../../../components/CardInstruction';

import { getSosBudServiceId } from '../../../form/PensosbudForm/functions';

const PNSLastStudy = ({ i18n, sosBudServiceList }) => {
  const lang = (type, params) => i18n(`pensosbud.tab3.${type}`, { ...params });
  const serviceId = getSosBudServiceId(sosBudServiceList, 'pns');

  const stepOuterList = [
    {
      label: i18n('pensosbud.step.take_number.title'),
      cta: i18n('pensosbud.step.take_number.cta'),
      link: `/pensosbud/registration/create?type=pns&serviceId=${serviceId}`
    },
    {
      label: i18n('pensosbud.step.download.title'),
      cta: i18n('pensosbud.step.download.cta', { type: i18n('pensosbud.tab3.title') }),
      linkType: true,
      iconCta: 'download',
      ctaColor: 'outline',
      link: 'https://drive.google.com/file/d/1R60tiXpqrAuTFtdietQ1cZz6V8raTjIi/view'
    }
  ];

  const instructionList = [
    i18n('pensosbud.instruction_step.original_doc'),
    i18n('pensosbud.instruction_step.surat_keterangan'),
    i18n('pensosbud.instruction_step.passport'),
    i18n('pensosbud.instruction_step.transkrip'),
    i18n('pensosbud.instruction_step.thesis'),
    i18n('pensosbud.instruction_step.surat_ijin_setkab'),
    i18n('pensosbud.instruction_step.sk_tugas'),
    i18n('pensosbud.instruction_step.laporan_hasil_belajar'),
    i18n('pensosbud.instruction_step.kjri_form'),
    i18n('pensosbud.instruction_step.send_all_doc'),
    i18n('pensosbud.instruction_step.min_3_days')
  ];

  return (
    <CardInstruction
      stepOuterList={stepOuterList}
      instructionList={instructionList}
      lang={lang}
    />
  );
};

PNSLastStudy.propTypes = {
  i18n: PropTypes.func,
  sosBudServiceList: PropTypes.array
};

const mapStateToProps = (state) => ({
  i18n: state.langReducer.i18n
});

export default connect(mapStateToProps)(PNSLastStudy);
